import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import type { DialogData, LayerMetadata, UpsertLayerMetadataBody } from '@app/types'
import { LayerDetail } from '@app/domains/layers/types/layers.types'

export const fetchLayers = async (): Promise<DialogData> => {
  const { data } = await apiClient.get<DialogData>(Endpoint.getLayers)
  return data
}

export const fetchLayerDetails = async (id: string) => {
  const { data } = await apiClient.get<LayerDetail[]>(`${Endpoint.getLayerDetails}/${id}`)
  return data[0]
}

export const upsertLayerMetadata = async (
  layerId: string,
  body: UpsertLayerMetadataBody,
): Promise<LayerMetadata> => {
  const { data } = await apiClient.put<LayerMetadata>(
    `${Endpoint.layerMetadata}/${layerId}/metadata`,
    body,
  )
  return data
}

export const deleteLayerMetadata = async (layerId: string): Promise<void> => {
  await apiClient.delete(`${Endpoint.layerMetadata}/${layerId}/metadata`)
}
